<template>
    <div class="table-search" :class="{'focused': focused}">
        <div>
            <label for="table-search-input">
                <search-icon/>
            </label>

            <input
                autocomplete="off"
                id="table-search-input"
                type="text"
                placeholder="Search"
                @focus="focused = true"
                @blur="focused = false"
                :value="value"
                @input="$emit('input', $event.target.value)"
            >

            <button
                v-if="value.length > 0"
                title="Clear Search"
                class="clear-table-search"
                @click.prevent.stop="$emit('clear')"
            >
                <close-icon/>
            </button>
        </div>
    </div>
</template>

<script>
import CloseIcon from 'src/components/icons/Close';

export default {
    props: ['value'],
    data() {
        return {
            focused: false,
        };
    },
    components: {
        CloseIcon,
    },
};
</script>
